import React from 'react';
import PropTypes from 'prop-types';
import {Radio, Flex} from '@spothero/ui';

const BorderedRadio = ({
    children,
    isSelected,
    isParent,
    value,
    radioStyles = {},
}) => {
    return (
        <Flex
            borderRadius="md"
            borderWidth="1px"
            borderColor={
                isParent
                    ? 'transparent'
                    : isSelected
                    ? 'primary.default'
                    : 'gray.200'
            }
        >
            <Radio
                width="100%"
                height={12}
                paddingX={4}
                alignItems="center"
                value={value}
                {...radioStyles}
            >
                {children}
            </Radio>
        </Flex>
    );
};

BorderedRadio.propTypes = {
    children: PropTypes.node.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isParent: PropTypes.bool,
    value: PropTypes.string.isRequired,
    radioStyles: PropTypes.object,
};

export default BorderedRadio;
